import PropTypes from "prop-types";
import styles from "./LoginFailureClosePopup.module.scss";

const LoginFailureClosePopup = ({
  show,
  title = "Subscription activation in progress",
  onClose,
}) => {
  if (!show) return null;

  return (
    <div role="dialog" aria-modal={true} aria-label={title} className={styles.overlay}>
      <div className={styles.card}>
        <div className={styles.header}>
          <h3 className={styles.title}>{title}</h3>

          <button type="button" onClick={onClose} className={styles.closeButton} aria-label="Close">
            ×
          </button>
        </div>

        <div className={styles.divider} />
        <div className={styles.message}>
          <p>
            We are getting your subscription ready and it can take up to <strong>15 minutes</strong>{" "}
            to fully activate your account.
          </p>

          <p>
            Please wait a few minutes then try to login again. Contact <strong>IT Support</strong>{" "}
            for any other technical enquiries.
          </p>
        </div>
      </div>
    </div>
  );
};

LoginFailureClosePopup.propTypes = {
  show: PropTypes.bool.isRequired,
  title: PropTypes.string,
  onClose: PropTypes.func.isRequired,
};

export default LoginFailureClosePopup;
